import React from 'react';
import { Mission, HeroHeader, Title } from './CompanyHero.styles.js';
import { XXL, LG  } from '@zendeskgarden/react-typography';
import { Row, Col } from '@zendeskgarden/react-grid';

const CompanyHero = (props) => { 
  return (
     <HeroHeader>
        <div>
          <Row>
            <Col md={12}>
              <div>
                <Mission bold blue center letterSpacing="true" paddingHorizontalSm uppercase tag="p">THE MRT MISSION</Mission>
                <XXL style={{margin: '0 auto', maxWidth: '1000px'}} center bold paddingTopLg navy tag="h1">
                 <Title>Streamline the process of acquiring and installing medical imaging equipment so that our clients can focus on what is important, their practice and their patients.</Title>
                </XXL>
                <LG center style={{margin: '0 auto', maxWidth: '900px'}} paddingTopMd navy light tag="h3">
                  We believe in the Patient First mentality and ask ourselves “would I feel comfortable trusting this equipment with my own family?” If the answer is no, then the job is not yet done. Every piece of equipment provided by MRT will look and perform like new, and every project will be executed with foremost professionalism.
                </LG>
                <LG center style={{margin: '0 auto', maxWidth: '900px'}} paddingTopMd navy light tag="h3">
                  As said on our Why Us page: We’ll gladly put our knowledge, products and personnel up against anyone in the business. We do things right the first time and we aren’t satisfied until we’ve exceeded your expectations.
                </LG>
              </div>

            </Col>
          </Row>
        </div>
      </HeroHeader>
      

  )
}


export default CompanyHero;
